var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordTableA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.25006C7.67525 3.25006 3.75 7.17526 3.75 11.9999C3.75 16.8249 7.67525 20.7501 12.5 20.7501C17.3247 20.7501 21.25 16.8249 21.25 11.9999C21.25 7.17526 17.3247 3.25006 12.5 3.25006ZM12.4999 23.0001C6.4346 23.0001 1.5 18.0655 1.5 11.9999C1.5 5.93466 6.4346 1.00006 12.4999 1.00006C18.5652 1.00006 23.4998 5.93466 23.4998 11.9999C23.4998 18.0655 18.5652 23.0001 12.4999 23.0001Z",
    fill: "#003C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4902 13.0351H13.7782L13.4922 11.9821C13.1932 10.9811 12.9332 9.87607 12.6472 8.83607H12.5952C12.3482 9.88907 12.0622 10.9811 11.7762 11.9821L11.4902 13.0351ZM14.8702 17.0001L14.1942 14.5301H11.0742L10.3982 17.0001H8.44824L11.5292 7.38007H13.7912L16.8852 17.0001H14.8702Z",
    fill: "#003C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordTableA);
export default __webpack_public_path__ + "static/media/recordTableA.e968d94746cc429c33360b486da795cf.svg";
export { ForwardRef as ReactComponent };